import { render, staticRenderFns } from "./ColegioIna.vue?vue&type=template&id=4c5be02a&scoped=true"
import script from "./ColegioIna.vue?vue&type=script&lang=js"
export * from "./ColegioIna.vue?vue&type=script&lang=js"
import style0 from "./ColegioIna.vue?vue&type=style&index=0&id=4c5be02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5be02a",
  null
  
)

export default component.exports